$(document).ready(function() {
    setInterval(function() {
        $(".af_discount_response").each(function() {
            var textNode = $(this).contents().filter(function() {
                return this.nodeType === 3 && this.textContent.includes("Remise appliquée.");
            });
            if (textNode.length > 0) {
                var text = textNode.text().trim();
                 if (text.endsWith("Remise appliquée.")) {
                    textNode.replaceWith(text.slice(0, -1)); 
                }
            }
        });
    }, 100);
});   


$(document).ready(function() {
  if ($('.New-banner-wrapperbox').hasClass('containerfull-banner-wrapper')) {
    $('body').addClass('full-banner-wrapper_Container');
  }
  setTimeout(() =>{
    var cookies = document.cookie;
    cookies.split(';').forEach(function(cookie){
      if(cookie.split('=')[0].trim() == 'discount_code'){
        $('.af_custom_coupon_text').val(cookie.split('=')[1].trim());
        $('.af_custom_apply_coupon_trigger').trigger('click');
      }
    })
  },1500)
});

$(document).ready(function(){
      var specificUrl = "https://www.rosegoldparis.com/?_ab=0&_fd=0&_sc=1";
      var anotherUrl = "https://www.rosegoldparis.com/";
    $(window).on('scroll', function() {
      var scroll = $(window).scrollTop(); 
              if (window.location.href === specificUrl || window.location.href === anotherUrl ) {
          if (scroll > 250) {
          $('.custom-homepage-header-wrapper').addClass("activeHeader");
        } else {
          $('.custom-homepage-header-wrapper').removeClass("activeHeader");
        }
      }
  });
});



$(document).ready(function(){
    setTimeout(function(){
  var idselected =  $('.main-wrpperbox').children('.active').attr('data-variant');
   $('.product_add_cart').attr('vid',idselected);
  },1000);
      $.fn.isInViewport = function() {
      var elementTop = $(this).offset().top;
      var elementBottom = elementTop + $(this).outerHeight() / 2;
      var viewportTop = $(window).scrollTop();
      var viewportHalf = viewportTop + $(window).height() / 2;
      return elementBottom > viewportTop && elementTop < viewportHalf;
    };
    
  $(window).on('scroll',function(){
      if($('.handleFetch').length > 0){
        var handleAll = [];
      $('.Listitem_icon').each(function() {
          var handleGet = $(this).children('.summary').children('a').attr('href'), handleGet = handleGet.replace('#','');
              handleAll.push(handleGet)
        })
      
        $('.handleFetch').each(function() {
          if ($(this).isInViewport()) {
         var aTTrb = $(this).attr('id');
              $('.Listitem_icon').removeClass('clickActive');
             if($.inArray(handleAll, aTTrb) !== 1){
              $('.Listitem_icon').each(function(){
                var customGet = $(this).children('.summary').children('a').attr('href'), customGet = customGet.replace('#','');
                if(customGet == aTTrb){
                  $(this).children('.summary').children('a').addClass('boldTextActive').css('font-weight',600);
                }else{
                
                  $(this).children('.summary').children('a').removeClass('boldTextActive').css('font-weight','');
                }
              })
            }
          }
          else{    
          }
        });
      }
    })

  var AccordianMN = document.querySelectorAll('.Accordionwrappbox-container');
  if(AccordianMN)
  AccordianMN.forEach(function(evt, key){
    if(key == 0){
      evt.querySelector('.product-accordaion-wrappbox').classList.add('active');
      evt.querySelector('.mainAccodain-body').style.display = 'block';
    }
  })

    if ($(window).width() < 749) {
    var showChar = 120;  // How many characters are shown by default
    var ellipsestext = "...";
    var moretext = "Lire plus";
    var lesstext = "Lire moins";
    $('.ContentGettingCropped').each(function() {
        var content = $(this).html();
        if(content.length > showChar) {
            var c = content.substr(0, showChar);
            var h = content.substr(showChar, content.length - showChar);
            var html = c + '<span class="moreellipses">' + ellipsestext+ '&nbsp;</span><span class="morecontent"><span>' + h + '</span><a class="morelink">' + moretext + '</a></span>';
            $(this).html(html);
         }
     });
    
    $(".morelink").click(function(){
      if($(this).hasClass("less")) {
      $(this).removeClass("less");
      $(this).html(moretext);
      } else {
      $(this).addClass("less");
      $(this).html(lesstext);
      }
      $(this).parent().prev().toggle();
      $(this).prev().toggle();
      return false;
    });
  }

$('.rc_widget__option__selector').click(function() {
    $(this).addClass('bg-black');
  });

if( $('.rosegold-review-main').length > 0 )  {  
$('.rosegold-review-main').slick({
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows : false,
  dots: true
  });
}

if( $('.accordian-mobile-review_pragraph').length > 0 )  {
  $('.accordian-mobile-review_pragraph').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots : true
  });
}

if( $('.main_image_product_slides').length > 0 )  {  
$('.main_image_product_slides').slick({
  slidesToShow: 2,
  slidesToScroll: 2,
  arrows: true,
  dots: true,
  infinite: false,
  prevArrow: '.slick-prev',
  nextArrow: '.slick-next'
}); 
}


 $('.list-view-items .list-view-item').each(function(index){
 if( index > 0 ){
 $(this).addClass('hidden');
  $('.search--less-than-2-results').css('display', 'block');   
 }
 });

$(document).on('click','.rosegold-faq-question',function(e){
    e.preventDefault();
  if( $(this).parents('.rosegold-faq-faq-block-grid').hasClass('accordionActive') ){
    $(this).parents('.rosegold-faq-faq-block-grid').toggleClass('accordionActive');
    $(this).parents('.rosegold-faq-faq-block-grid').children('.rosegold-faq-content-question').slideToggle();
  }
  else{
    $('.rosegold-faq-faq-block-grid').removeClass('accordionActive');
    $('.rosegold-faq-content-question').slideUp();
    $(this).parents('.rosegold-faq-faq-block-grid').toggleClass('accordionActive');
    $(this).parents('.rosegold-faq-faq-block-grid').children('.rosegold-faq-content-question').slideToggle();
  }
}); 
});

 $(document).on('click', '[js-tickycartAdd]', function(e){
  e.preventDefault();
   var textChnage = $(this);
   var data = $(this).attr('productid'); var qty = $('[newinputqtycrt]').val();
   $.ajax({
    url:'/cart/add.js',
    type:'POST',
    dataType: 'json',
    data: "quantity="+qty+"&id="+data,
    success: function(response){
      $.ajax({
        type: 'GET',
        url: '/cart',
        dataType: 'html',
        success: function(response) {
          $('#cartForm').load(' #cartForm');
          $('[data-cart-count]').html($(response).find('[data-cart-count]').html())
          $('.cart_drawer').html($(response).find('.cart_drawer').html()).addClass('cart_drawer_open');
          $('body').addClass('drawer_open');	
        },
      });
    }
  });
});

 $(document).on('click', '.customOffer', function(e){
  e.preventDefault();
  var textChnage = $(this);
  var data = $(this).attr('vid'); var qty = 1;
  setTimeout(function() {
  $('.cart_drawer').addClass('cart_drawer_open');
  $('body').addClass('drawer_open');
  }, 2000);
   $.ajax({
    url:'/cart/add.js',
    type:'POST',
    dataType: 'json',
    data: "quantity="+qty+"&id="+data,
    success: function(response){
      $.ajax({
        type: 'GET',
        url: '/cart',
        dataType: 'html',
        success: function(response) {
          $('#cartForm').load(' #cartForm');
          $('[data-cart-count]').html($(response).find('[data-cart-count]').html());
         
     	 },
      });
    }
  });
}); 







setInterval(function(){
  if($.trim($('.announcementwrapper .cart-shipping__numOuter.onlyShowDesk').html()) != ''){
    $('.announcementwrapper .cartshippingtext.onlyForHeader.onlyShowDesk').hide();
  }else if($.trim($('.announcementwrapper .cart-shipping__numOuter.onlyShowDesk').html()) == ''){
    $('.announcementwrapper .cartshippingtext.onlyForHeader.onlyShowDesk').show();
  }
  if($('.announceShippingTxt').length > 0){
    var shpngTxt = $('.announcementinner-container .cartshippingtext.onlyForHeader').html();
    $('.announceShippingTxt').html(shpngTxt);
  }
  if($('.ancShipTxtDisc').length > 0){
    var discTxt = $.trim($('.announcementinner-container .cart-shipping__numOuter').html());
    if(discTxt){
      $('.announceShippingTxt').hide();         
    }else{
      $('.announceShippingTxt').show();
    }
    $('.ancShipTxtDisc').html(discTxt)
  }
  if($('.cvOuterLeftDiscCoupon .exm_cartsummary_vip_discount').length > 0){
    var RosePlsDis = $.trim($('.cvOuterLeftDiscCoupon .exm_cartsummary_vip_discount .exm_subtotal_value b').html()), 
    totalDiscount = parseFloat($.trim($('.prize-discountcontent').attr('discNatural'))),
    currencySymbol='€';
    RosePlsDis = RosePlsDis.replace(currencySymbol,'');
    RosePlsDis = RosePlsDis.replace(',','.');
    RosePlsDis = RosePlsDis.replace('-','');
    RosePlsDis = $.trim(RosePlsDis);
    let discountSprt = (totalDiscount-RosePlsDis);
    
    if(discountSprt > 0){
      $('.estimated-progress').removeClass('hide');
      discountSprt = discountSprt.toString();
      discountSprt = discountSprt.replace('.',',')+currencySymbol;
      $('.prize-discountcontent').html('-'+discountSprt);
    }else{
      $('.prize-discountcontent').html('-0,00€');
      $('.estimated-progress').removeClass('hide');
    }
  }
  },200);



$(document).on('click','.variant-selectcv',function(){
  var variantId = $(this).attr('Idvariant'), variantMedia = $(this).attr('VariantMedia'), variantTitle = $(this).attr('VariantTitle');
  $(this).parents('.swatch-element').addClass('active').siblings().removeClass('active');
  $('[js-tickycartAdd]').attr('productid',variantId);
  $('[js-tickycartaddingwpsccs]').attr('productid',variantId);
  $('.product_add_cart').attr('vid',variantId);
  $('[newinputqtycrt]').val(1);
  if(variantMedia){
    if(document.querySelector('.prd-MediaMN')){
    document.querySelector('.prd-MediaWrpr img').src = variantMedia;
    document.querySelector('.prd-MediaWrpr img').srcset = variantMedia;
    document.querySelector('.prd-VarntTileWrpr').innerHTML = variantTitle;
    }
  }
});

  $(function() {
  $('.popup-main-wrapper').click(function() { 
  $(this).parents('.main-containrwrap-box').next('.main-wrpperbox').slideDown();
  $(this).parents('.main-containrwrap-box').addClass('active');
  $('.maincontainer-product-selected').addClass('active');
  });
  });
  
  $(function() { 
  $('.cross-closeicon').click(function() { 
  $(this).parents('.main-containrwrap-box').next('.main-wrpperbox').slideUp();
  $(this).parents('.main-containrwrap-box').removeClass('active');  
  $('.maincontainer-product-selected').removeClass('active');                                              
  });
  });

  setTimeout(function() {
  $('.Listitem_icon').on('click', function() {
  $(this).parents('.summary-main-conatiner').children('.summary-wrapper_box').removeClass('active');
  });
  },6000);

  $(document).on('click','[js-authorize-navigation]', function(e){
    e.preventDefault();
    var TargetDiv = $(this).attr('href');
           $('html, body').animate({
        scrollTop: $(TargetDiv).offset().top -200
    }, 500);
  })

/*end*/

/*quantity buttons*/

$(document).on('click', '[name="checkout"]', function(){
  $(this).children('span').addClass('hide').siblings('.loading-overlay__spinner').removeClass('hide');
  setTimeout(function(){ $(this).children('span').removeClass('hide').siblings('.loading-overlay__spinner').addClass('hide'); },500);
});

$(document).on('click', '.qtyplus', function(e){
  e.preventDefault();
  console.log('hurray');
  var quan = $(this).closest('.cart-para2 ').find('.quantity-input');
  quan.val(+quan.val() + 1);
  console.log(quan);
  var totalprice = parseInt(quan.val());
  var pricecapture = $('.upd-pro-price').attr('data-price');
  var totalBound = (pricecapture*totalprice)/100; 
  $('.upd-pro-price').html(totalBound+'€');

  var comp_price = $('.upd-pro-cpprice').attr('data-cprice');
  var comptotal = (comp_price*totalprice)/100;
  if(comptotal>0){
  $('.upd-pro-cpprice').html(comptotal+'€');
  }
});

$(document).on('click', '.qtyminus', function(e){
  e.preventDefault();
  var quan = $(this).closest('.cart-para2').find('.quantity-input');
  if(quan.val() > 1) quan.val(+quan.val() - 1);
  var totalprice = parseInt(quan.val());
  var pricecapture = $('.upd-pro-price').attr('data-price');
  var totalBound = (pricecapture*totalprice)/100;
  $('.upd-pro-price').html(totalBound+'€');

  var comp_price = $('.upd-pro-cpprice').attr('data-cprice');
  var comptotal = (comp_price*totalprice)/100;
  if(comptotal>0){
  $('.upd-pro-cpprice').html(comptotal+'€');
   }
 });

$('a[href^="#"]').on('click',function (e) {
  var target = this.hash,
      $target = $(target);

  $('html, body').stop().animate({
    'scrollTop': $target.offset().top-40
  }, 2000, 'swing', function () {
    window.location.hash = target;
  });
});

$(function () {
        var url = window.location.pathname,
    urlRegExp = new RegExp(url.replace(/\/$/, '') + "$");  
        $('.medium-up--hides a').each(function () {
           if (urlRegExp.test(this.href.replace(/\/$/, ''))) {
                $(this).addClass('active');
            }
        });
    });

if ($(window).width() < 768) {

 $(function () {
  var url = window.location.pathname,
  urlRegExp = new RegExp(url.replace(/\/$/,''));
  $('#AccessibleNav a').each(function(){
        if(urlRegExp.test(this.href)){
          $(this).addClass('selectedActive');
        }
    });
});
}else{
   $(function () {
  var url = window.location.pathname,
  urlRegExp = new RegExp(url.replace(/\/$/,''));
  $('#AccessibleNav a').each(function(){
        if(urlRegExp.test(this.href)){
          $(this).removeClass('selectedActive');
        }
    });
});
}

$(document).on('keyup','[data-predictive-search-drawer-input]',function(){
  if($(this).val().includes('offeret') || $(this).val().includes('off') || $(this).val().includes('offer') || $(this).val().includes('o') || $(this).val().includes('of') || $(this).val().includes('offe') || $(this).val().includes('offere') ){
    $(this).siblings('.predictive-search-wrapper').hide();
  }
})



$(document).on('click', '[videtag]' , function(e){
  e.preventDefault();
 var VideoTag =  $(this).attr('videtag');
    $('body').addClass('videoActive');
 
 $('body').append(`
   <div class="WrapperPopupWithThumbnail">
     <div class="Container__Wp_thumbnail">
        <div class="CrossPopupThumb"><svg xmlns="http://www.w3.org/2000/svg" version="1.0" width="96.000000pt" height="96.000000pt" viewBox="0 0 96.000000 96.000000" preserveAspectRatio="xMidYMid meet">
<g transform="translate(0.000000,96.000000) scale(0.100000,-0.100000)" fill="#000000" stroke="none">
<path d="M212 748 c-7 -7 -12 -19 -12 -27 0 -9 51 -66 112 -128 l113 -113 -113 -113 c-61 -62 -112 -119 -112 -128 0 -19 20 -39 39 -39 9 0 66 51 128 112 l113 113 113 -113 c62 -61 119 -112 128 -112 19 0 39 20 39 39 0 9 -51 66 -112 128 l-113 113 113 113 c61 62 112 119 112 128 0 19 -20 39 -39 39 -9 0 -66 -51 -128 -112 l-113 -113 -113 113 c-62 61 -119 112 -128 112 -8 0 -20 -5 -27 -12z"/>
</g>
</svg></div>
<span class="container_overlay-video"> </span>
        <div class="container__Video_init">
          <div class="ContainerVideoExecuted">
            <video playsinline="true" autoplay="true" muted="true">
              <source src=${VideoTag} type="video/mp4">
            </video>
           </div>
        </div>
        </div>
    </div>
  
 `)
});

$(document).on('click', '.CrossPopupThumb' , function(e){
  e.preventDefault();
  $('.WrapperPopupWithThumbnail').remove();
     $('body').removeClass('videoActive');
});
  
$(document).click(function (e) {
  if (!$(e.target).closest('.video_wrapper, .Container__Wp_thumbnail').length) {
    $('.WrapperPopupWithThumbnail').remove();
    $('body').removeClass('videoActive');
  }
});

document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.faq-question').forEach(function(question) {
    question.addEventListener('click', function(e) {
        e.preventDefault();
        var parentBlock = this.closest('.page-faq-block-grid');
        var contentQuestion = parentBlock.querySelector('.page-faq-content-question');
        
        if (parentBlock.classList.contains('active-accordion')) {
            parentBlock.classList.toggle('active-accordion');
            contentQuestion.style.display = (contentQuestion.style.display === 'none' || contentQuestion.style.display === '') ? 'block' : 'none';
        } else {
            document.querySelectorAll('.page-faq-block-grid').forEach(function(block) {
                block.classList.remove('active-accordion');
                block.querySelector('.page-faq-content-question').style.display = 'none';
            });
            
            parentBlock.classList.toggle('active-accordion');
            contentQuestion.style.display = (contentQuestion.style.display === 'none' || contentQuestion.style.display === '') ? 'block' : 'none';
        }
    });
}); 

document.addEventListener('click', function(event) {
  if (event.target.classList.contains('.contenttext.OnlyForMobile_view')) {
      document.body.classList.add('popupActive');
      document.querySelector('.product-popup-main').classList.add('active');
  }
});

  
document.addEventListener('click', function(event) {
  if (event.target.classList.contains('nextclick')) {
      document.body.classList.add('popupActive');
      document.querySelector('.product-popup-main').classList.add('active');
  }
});   

document.addEventListener('click', function(event) {
    if (event.target.matches('[JSCollectionPOP], .nextclick')) {
        event.preventDefault();
        document.body.classList.add('popupActive');
        document.querySelector('.product-popup-main').classList.add('active');
    }
});

document.addEventListener('click', function(event) {
    if (event.target.classList.contains('popup-right-content')) {
      document.body.classList.remove('popupActive');
      document.querySelector('.product-popup-main').classList.remove('active');
    }
});


var nextiframe = iframeSelectors;
iframeGlobal(nextiframe);

    document.querySelectorAll('.AffilAccordianMN').forEach(function(evt){
    if(evt)
    evt.querySelector('.AffilAccordTopHead').addEventListener('click',function(e){
      e.preventDefault();
      var objj = this.parentNode.parentNode;
      document.querySelectorAll('.AffilAccordianMN').forEach(function(target){
        if(target != objj)
        target.classList.remove('togglerActive');
      })
      this.parentNode.parentNode.classList.toggle('togglerActive');
    })
    evt.querySelectorAll('.AffilAccTogl').forEach(function(evnt){
      if(evnt.classList.contains('AffilAccTogl'))
      evnt.addEventListener('click',function(e){
        e.preventDefault();
        var objjInner = this;
        evt.querySelectorAll('.AffilAccTogl').forEach(function(target){
        if(target != objjInner)
          target.classList.remove('accordianActive');
        })
        this.classList.toggle('accordianActive');
      })
    })
  })




  
  
});

  